import produce from 'immer';
import { theme, nightTheme } from '../components/global/theme';
import { isNight, isFrontpage } from '../helpers/themeHelpers/themeHelpers';

import {
	SET_NIGHT_THEME_FULFILLED,
	SET_DAY_THEME_FULFILLED
} from '../constants/theme.actions';

import {
	FETCH_PAGE_FULFILLED
} from '../constants/page.actions';

const shouldUseNightTheme = isNight() && isFrontpage();

const apartmentsReducer = produce(
	(draft, action) => {
		switch(action.type) {
			case (SET_NIGHT_THEME_FULFILLED): {
				draft.isNightTheme = true;
				draft.theme = nightTheme;
				break;
			}
			case (SET_DAY_THEME_FULFILLED): {
				draft.isNightTheme = false;
				draft.theme = theme;
				break;
			}
			case (FETCH_PAGE_FULFILLED): {
				const shouldUseNight = isNight() && isFrontpage();
				draft.isNightTheme = isNight() && isFrontpage();
				draft.theme = shouldUseNight ? nightTheme : theme;
				break;
			}
			default: {
				break;
			}
		}
	},
	{
		isNightTheme: shouldUseNightTheme,
		theme: shouldUseNightTheme ? nightTheme : theme
	}
);

export default apartmentsReducer;
